export const toLogoutAndBack = (currentUrl, logoutPath) => {
  const postLogoutUrl = new URL(currentUrl);
  postLogoutUrl.searchParams.delete('forceLogin');
  const encodedUrl = encodeURIComponent(postLogoutUrl.toString());
  return `${logoutPath}?post_logout_redirect_uri=${encodedUrl}`;
};
